var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"container_check version_2"},[_vm._v(_vm._s(_vm.label)+" "),_c('input',{class:_vm.classes,attrs:{"type":"checkbox","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.checkedstate}}),_c('span',{staticClass:"checkmark"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }